import React, { useState, useEffect, useRef } from "react";
import "./Chatbot.css";
import chatIcon from './images/JibuBotLogo.png';

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [showChat, setShowChat] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupCount, setPopupCount] = useState(0);
  const [popupActive, setPopupActive] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const chatBoxRef = useRef(null);

  

  // ✅ Initial welcome message
  useEffect(() => {
    setMessages([
      { type: "bot", text: "Hi, this is JibuBot from AstraSight. Ask me anything about AstraSight or JibuBot!" }
    ]);
  }, []);


  const scrollToBottom = () => {
    chatBoxRef.current?.scrollTo({ 
      top: chatBoxRef.current.scrollHeight, 
      behavior: 'smooth' 
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

 // ✅ Popup logic + trigger badge
  useEffect(() => {
    if (popupActive && popupCount < 3) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        setShowNotification(true); // ✅ show badge
        setTimeout(() => setShowPopup(false), 3000);
        setPopupCount((prev) => prev + 1);
      }, 3000 * (popupCount + 1));

      return () => clearTimeout(timer);
    }
  }, [popupCount, popupActive]);


  const handleSend = async () => {
    if (!input.trim()) return;

    const userMsg = { type: "user", text: input };
    setMessages(prev => [...prev, userMsg]);

    setInput("");

    const typingMsg = { type: "bot", text: "...typing", typing: true };
    setMessages(prev => [...prev, typingMsg]);

    const res = await fetch("http://localhost:5000/chatbot/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ message: input, user_id: "123" })
    });

    const data = await res.json();

    setMessages(prev =>
      prev.filter(msg => !msg.typing).concat({ type: "bot", text: data.response })
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

const handleChatToggle = () => {
  setShowChat(prev => !prev);
  setShowNotification(false); // hide badge on open
  if (!showChat) setPopupActive(false);



    // ✅ Stop popup forever once user interacts
    if (!showChat) {
      setPopupActive(false);
      setShowPopup(false);
    }
  };

  return (
    <>
      {/* Chat Icon with Badge */}
      <div id="chat-icon" onClick={handleChatToggle} >
        <img
          src={chatIcon}
          alt="Chat Icon"
          style={{ width: "30px", height: "30px", cursor: "pointer" }}
        />
        {showNotification && (
          <span className="chat-badge">1</span>
        )}
      </div>

      {/* Popup */}
      {showPopup && popupActive && (
        <div className="chat-popup">
          Hi, want to know more about me and AstraSight? Just click me!
        </div>
      )}

      {/* Chat Window */}
      {showChat && (
        <div id="chat-container">
          <div id="chat-header">Chat with us

            <span className="close-btn" onClick={handleChatToggle}>×</span>
          </div>
          <div id="chat-box" ref={chatBoxRef}>
            {messages.map((msg, i) => (
              <div 
                key={i} 
                className={`message ${msg.type}-message ${msg.typing ? 'typing' : ''}`}
              >
                {msg.typing ? (
                  <div className="dots">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                  </div>
                ) : (
                  msg.text
                )}
              </div>
            ))}
          </div>
          <div id="chat-input-container">
            <input
              id="user-input"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type a message..."
            />
            <button onClick={handleSend}>▶</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
